global.BASE_URL = 'http://101.201.196.238/';



// WEBPACK FOOTER //
// ./src/config/global.js